import { ChevronRightIcon, HomeIcon } from "@heroicons/react/20/solid";

type Page = {
  name: string;
  href: string;
  current: boolean;
};

const Breadcrumb = ({ pages }: { pages?: Page[] }) => {
  return (
    <>
      <nav className="flex overflow-hidden" aria-label="Breadcrumb">
        <ol className="inline-flex items-center space-x-4">
          <li>
            <div className="whitespace-nowrap">
              <button className="text-gray-400 hover:text-gray-500">
                <a href="/dashboard">
                <HomeIcon
                  className="h-5 w-5 flex-shrink-0"
                  aria-hidden="true"
                />
                </a>
                <span className="sr-only">Home</span>
              </button>
            </div>
          </li>
          {pages &&
            pages.map((page) => (
              <li key={page.name}>
                <div className="flex items-center whitespace-nowrap">
                  <ChevronRightIcon
                    className="h-5 w-5 flex-shrink-0 text-gray-400"
                    aria-hidden="true"
                  />
                  <a
                    href={page.href}
                    className={`ml-4 text-sm font-medium hover:text-gray-700 ${
                      page.current ? "text-brand-blue-400" : "text-gray-500"
                    }`}
                    aria-current={page.current ? "page" : undefined}
                  >
                    {page.name}
                  </a>
                </div>
              </li>
            ))}
        </ol>
      </nav>
    </>
  );
};

export default Breadcrumb;
